import { FC } from 'react';
import RibbleButton from 'v3/common/global/components/RibbleButton';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const { productName } = ApplicationDomainUtility;

const Faq: FC = () => {
  return (
    <section className="faq">
      <div className="container">
        <div className="d-flex align-items-center justify-content-center">
          <h2>
            Frequently Asked <span>Questions</span>
          </h2>
        </div>
        <div className="row d-flex align-items-start justify-content-center">
          <div className="col-lg-10">
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h3 className="accordion-header">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    How to log in to {productName}?
                  </button>
                </h3>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse show"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    To log in, click the Login With Broker button, choose your broker, and enter the
                    respective credentials. Finally, select Login to access the {productName} dashboard.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h3 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    Do I need coding skills to use {productName}?
                  </button>
                </h3>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    No. {productName} is entirely a no-code algorithmic trading software that allows you to
                    create, test, and execute trading strategies in the live market without needing to write
                    any code.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h3 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    Can I backtest my strategies before going live?
                  </button>
                </h3>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    You can backtest your created strategies using historical data before going live.
                    Additionally, the Paper Trade feature allows you to test your strategy in the live market
                    with virtual money.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h3 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    How does {productName} integrate with brokers or TradingView?
                  </button>
                </h3>
                <div
                  id="collapseFour"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    {productName} offers seamless broker integration for automated order execution and
                    real-time data. You can also connect TradingView alerts directly to {productName},
                    enabling live trades based on your TradingView strategy signals.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h3 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                  >
                    Is there a free trial available?
                  </button>
                </h3>
                <div
                  id="collapseFive"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    Yes, {productName} Pro plan gets a 7-day free trial for new users. You can unlock the free
                    trial by selecting the 7-day free trial option when signing up for {productName}.
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center">
              <RibbleButton name="More Questions" href="/faq" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Faq;
